import { create, METHOD } from '../utils'

export default {
    page: create({
        name: "page",
        url: "/web/v1/news/list",
        method: METHOD.GET
    }),
}